"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/* eslint-disable new-cap */
/* eslint-disable no-shadow */
/* eslint-disable no-lonely-if */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-var */
var _ = require('lodash');
// eslint-disable-next-line import/no-extraneous-dependencies
var loki = require('lokijs');
module.exports = /*@ngInject*/function ($q) {
  var _memoryDb = null;
  var _diskDb = null;
  var _diskDbPromise = null;
  var _memoryDbPromise = null;
  var service = {
    persistInFile: function persistInFile() {
      var options = {
        adapter: new LokiCordovaFSAdapter({
          prefix: 'rss-inspect'
        }),
        autosave: false,
        throttledSaves: false
      };
      return service._initDiskDb(options);
    },
    persistInIndexedDb: function persistInIndexedDb() {
      var options = {
        adapter: null,
        autosave: false,
        throttledSaves: false
      };
      var indexedDbAdapter = new LokiIndexedAdapter('rss-inspect');
      options.adapter = new loki.LokiPartitioningAdapter(indexedDbAdapter, {
        paging: false
      });
      return service._initDiskDb(options);
    },
    _initDiskDb: function _initDiskDb(options) {
      if (_diskDbPromise) {
        return _diskDbPromise;
      }
      _diskDbPromise = new Promise(function (resolve, reject) {
        _diskDb = new loki('inspections', options);
        _diskDb.loadDatabase({}, function (result) {
          if (result instanceof Error) {
            reject(result || new Error('Disk Database load failed'));
          }
          if (!_diskDb.getCollection('report')) {
            _diskDb.addCollection('report', {
              unique: ['_id']
            });
          }
          if (!_diskDb.getCollection('reportsToDelete')) {
            _diskDb.addCollection('reportsToDelete', {
              unique: ['_id']
            });
          }
          resolve(_diskDb);
        });
      });
      return _diskDbPromise;
    },
    initMemoryDb: function initMemoryDb() {
      if (_memoryDbPromise) {
        return _memoryDbPromise;
      }
      _memoryDbPromise = new Promise(function (resolve, reject) {
        var options = {
          adapter: new loki.LokiMemoryAdapter(),
          autosave: false
        };
        _memoryDb = new loki('inspect-configurations', options);
        _memoryDb.loadDatabase({}, function (result) {
          if (result instanceof Error) {
            reject(result || new Error('Memory Database load failed'));
          }
          if (!_memoryDb.getCollection('configuration')) {
            _memoryDb.addCollection('configuration', {
              unique: ['_id']
            });
          }
          if (!_memoryDb.getCollection('checklist')) {
            _memoryDb.addCollection('checklist', {
              unique: ['_id']
            });
          }
          if (!_memoryDb.getCollection('party')) {
            _memoryDb.addCollection('party', {
              unique: ['_id']
            });
          }
          if (!_memoryDb.getCollection('partyToPeople')) {
            _memoryDb.addCollection('partyToPeople', {
              unique: ['_id']
            });
          }
          if (!_memoryDb.getCollection('partyToLocation')) {
            _memoryDb.addCollection('partyToLocation', {
              unique: ['_id']
            });
          }
          if (!_memoryDb.getCollection('location')) {
            _memoryDb.addCollection('location', {
              unique: ['_id']
            });
          }
          if (!_memoryDb.getCollection('routingGroup')) {
            _memoryDb.addCollection('routingGroup', {
              unique: ['_id']
            });
          }
          resolve(_memoryDb);
        });
      });
      return _memoryDbPromise;
    },
    collection: function collection(_collection) {
      var isReportCollection = _collection === 'report' || _collection === 'reportsToDelete';
      var db = isReportCollection ? _diskDb : _memoryDb;
      // eslint-disable-next-line no-unused-vars
      return $q(function (resolve, reject) {
        if (db) {
          resolve(db.getCollection(_collection));
        } else {
          if (isReportCollection) {
            var initDiskDbPromise = window.cordova && window.cordova.file ? service.persistInFile() : service.persistInIndexedDb();
            initDiskDbPromise.then(function (db) {
              resolve(db.getCollection(_collection));
            });
          } else {
            service.initMemoryDb().then(function (db) {
              resolve(db.getCollection(_collection));
            });
          }
        }
      });
    },
    save: function () {
      var _save = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(persistInDisk, cb) {
        var db;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              db = persistInDisk ? _diskDb : _memoryDb;
              if (!cb) {
                _context.next = 5;
                break;
              }
              db.throttledSaveDrain(function (success) {
                if (success) {
                  db.saveDatabase(cb);
                } else {
                  cb();
                }
              }, {
                recursiveWaitLimit: true,
                recursiveWaitLimitDuration: 2000
              });
              _context.next = 7;
              break;
            case 5:
              _context.next = 7;
              return db.saveDatabase();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function save(_x, _x2) {
        return _save.apply(this, arguments);
      }
      return save;
    }(),
    stripLokiInformation: function stripLokiInformation(obj) {
      delete obj.$loki;
      delete obj.meta;
      if (obj.configuration) {
        delete obj.configuration.$loki;
        delete obj.configuration.meta;
      }
    },
    upsertCollection: function upsertCollection(activeIds, items, collection, forceSync) {
      if (!items || items.length === 0 || !collection) {
        return;
      }
      if (collection.data.length > 0 && !forceSync) {
        // remove existing items in the collection before insert as new
        collection.removeWhere({
          _id: {
            $in: _.map(items, function (item) {
              return item._id;
            })
          }
        });

        // remove all data from collection where activeIds not in collection (if something gets removed from server)
        if (activeIds.length > 0) {
          collection.removeWhere({
            _id: {
              $containsNone: activeIds
            }
          });
        }
      } else {
        collection.removeDataOnly();
      }
      collection.insert(items);
    },
    upsertAllCollection: function upsertAllCollection(data, options, callback) {
      $q.all([service.collection('configuration'), service.collection('checklist'), service.collection('party'), service.collection('partyToPeople'), service.collection('partyToLocation'), service.collection('location'), service.collection('routingGroup')]).then(function (values) {
        service.upsertCollection(_.map(data.configuration, function (configuration) {
          return configuration._id;
        }), data.configuration, values[0], options.forceSync);
        service.upsertCollection(_.map(data.configuration, function (configuration) {
          return configuration.checklist;
        }), data.checklist, values[1], options.forceSync);
        service.upsertCollection(_.map(data.configuration, function (configuration) {
          return configuration.party;
        }), data.party, values[2], options.forceSync);
        service.upsertCollection(_.map(data.configuration, function (configuration) {
          return configuration.partyToPeople;
        }), data.partyToPeople, values[3], options.forceSync);
        service.upsertCollection(_.map(data.configuration, function (configuration) {
          return configuration.partyToLocation;
        }), data.partyToLocation, values[4], options.forceSync);
        service.upsertCollection(
        // eslint-disable-next-line arrow-body-style
        _.map(data.configuration, function (configuration) {
          return configuration.location;
        }), data.location, values[5], options.forceSync);
        service.upsertCollection(_.map(data.configuration, function (configuration) {
          return configuration.routingGroup;
        }), data.routingGroup, values[6], options.forceSync);
        service.save();
        return callback ? callback() : {
          ok: 1
        };
      });
    },
    clearAllData: function clearAllData(callback) {
      $q.all([service.collection('configuration'), service.collection('checklist'), service.collection('party'), service.collection('partyToPeople'), service.collection('partyToLocation'), service.collection('location'), service.collection('routingGroup')]).then(function (results) {
        results.forEach(function (data) {
          return data.clear();
        });
        service.save();
        return callback ? callback({
          ok: 1
        }) : {
          ok: 1
        };
      });
    },
    //https://gist.github.com/solenoid/1372386
    generateMongoObjectId: function generateMongoObjectId() {
      // eslint-disable-next-line no-bitwise
      var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
      return (
        // eslint-disable-next-line no-bitwise
        timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, function () {
          return (Math.random() * 16 | 0).toString(16);
        }).toLowerCase()
      );
    }
  };
  return service;
};